<script>
import { mapGetters } from 'vuex'
export default {

    name: 'CreateZonePrice',

    data() {
        return {
            companySearch: null,
            packetSearch: null,
            zoneSearch: null,
            model: {
                zone_id: null,
                destination_zone_id: null,
                company: null,
                packed_id: null,
                packet: null,
                company_id: null,
                is_percent: false,
                is_relative: false,
                value: 0.0,
                value_24h: null,
                value_12h: null,
                value_6h: null,
            }
        }
    },

    computed: {
        ...mapGetters({
            'companies': 'companies',
            'packets': 'packets',
            'services': 'services',
            'orderTypes': 'orderTypes',
            'zones': 'zones',
        }),
    },

    mounted() {
        this.$store.dispatch('title', this.$t('ZONES.ZONE_PRICES.NEW'))
        this.fetchCompanies()
        this.fetchZones()
    },

    methods: {
        save() {
            this.$store.dispatch('zonesOverridesAdd', this.model)
                .then(() => {
                    this.$router.push({ name: 'zone-prices' })
                })
        },

        fetchCompanies() {
            this.$store.dispatch('companiesFetchList', {
                search: this.companySearch,
                nopaged: true,
            })
        },

        fetchZones() {
            this.$store.dispatch('zonesFetchList', {
                search: this.zoneSearch,
                nopaged: true,
            })
        },

        setCompany(company) {
            if (company) {
                this.model.company_id = company.id
            } else {
                this.model.company_id = null
            }
            this.model.company = company
        },

        setPacket(packet) {
            if (packet) {
                this.model.packet_id = packet.id
            } else {
                this.model.packet_id = null
            }
            this.model.packet = packet
        },

        setZone(zone) {
            if (zone) {
                this.model.zone_id = zone.id
            } else {
                this.model.zone_id = null
            }
            this.model.zone = zone
        },

        setDestinationZone(zone) {
            if (zone) {
                this.model.destination_zone_id = zone.id
            } else {
                this.model.destination_zone_id = null
            }
            this.model.destination_zone = zone
        },

        toggleValue(key, val) {
            if (val) {
                this.model[key] = 1
            } else {
                this.model[key] = null
            }
        },
    }

}
</script>

<template lang="pug">
acrm-panel(style="z-index: 1000")
    acrm-heading(:level="4") {{ $t('ZONES.ZONE_PRICES.ZONE_PRICE') }}
    .row.mb-2
        .col-24.col-md-12.col-xl-12
            acrm-multi-select.mb-3.mb-sm-0(
                :options="services"
                :multiple="false"
                track-by="id"
                option-label="translated"
                :value="model.service_id"
                @input="model.service_id = $event.id"
            ) {{ $t('ORDERS.FIELDS.SERVICE')}}
        .col-24.col-md-12.col-xl-12
            acrm-multi-select(
                :value="model.order_type_id"
                @input="model.order_type_id = $event.id"
                track-by="id"
                option-label="translated"
                :options="orderTypes"
                :multiple="false"
            ) {{ $t('ORDERS.FIELDS.ORDER_TYPE')}}
    .row.mb-2
        .col-24.col-md-12.col-xl-12
            acrm-multi-select.mb-3.mb-sm-0(
                :options="companies.data"
                :multiple="false"
                track-by="id"
                option-label="name"
                @search="companySearch = $event; fetchCompanies()"
                v-model="model.company"
                @input="setCompany($event)"
                :placeholder="$t('COMPANIES.NAME')"
            ) {{ $t('ORDERS.FIELDS.CUSTOMER_COMPANY_ID')}}
        .col-24.col-md-12.col-xl-12
            acrm-multi-select.mb-3.mb-sm-0(
                :options="packets"
                :multiple="false"
                track-by="id"
                option-label="name"
                v-model="model.packet"
                @input="setPacket($event)"
                :placeholder="$t('COMPANIES.PACKETS')"
            ) {{ $t('ORDERS.FIELDS.PACKET_ID')}}
    .row.mb-2
        .col-24.col-md-12.col-xl-12
            acrm-multi-select.mb-3.mb-sm-0(
                :options="zones.data"
                :multiple="false"
                track-by="id"
                option-label="name"
                @search="zoneSearch = $event; fetchZones()"
                v-model="model.zone"
                @input="setZone($event)"
                :placeholder="$t('ZONES.ZONE')"
            ) {{ $t('ZONES.ZONE') }}
        .col-24.col-md-12.col-xl-12
            acrm-multi-select.mb-3.mb-sm-0(
                :options="zones.data"
                :multiple="false"
                track-by="id"
                option-label="name"
                @search="zoneSearch = $event; fetchZones()"
                v-model="model.destination_zone"
                @input="setDestinationZone($event)"
                :placeholder="$t('ZONES.DESTINATION_ZONE')"
            ) {{ $t('ZONES.DESTINATION_ZONE') }}
    .row.mb-2
        .col-24.col-md-12.col-xl-12
            acrm-input-line(v-model="model.value" type="number") {{ $t('ZONES.OVERRIDE_FIELDS.VALUE') }}
        .col-24.col-md-12.col-xl-12
            acrm-input-line(v-model="model.value_km" type="number") {{ $t('ZONES.OVERRIDE_FIELDS.VALUEKM') }}
    .row.mb-2
        .col-24.col-md-8.col-xl-8.d-flex.align-items-center.justify-content-between
            acrm-input-line(:disabled="model.value_24h == null" v-model="model.value_24h" type="number") {{ $t('ZONES.OVERRIDE_FIELDS.VALUE24H') }}
            acrm-input-switch(:value="model.value_24h != null" @input="toggleValue('value_24h', $event)")
        .col-24.col-md-8.col-xl-8.d-flex.align-items-center.justify-content-between
            acrm-input-line(:disabled="model.value_12h == null" v-model="model.value_12h" type="number") {{ $t('ZONES.OVERRIDE_FIELDS.VALUE12H') }}
            acrm-input-switch(:value="model.value_12h != null" @input="toggleValue('value_12h', $event)")
        .col-24.col-md-8.col-xl-8.d-flex.align-items-center.justify-content-between
            acrm-input-line(:disabled="model.value_6h == null" v-model="model.value_6h" type="number") {{ $t('ZONES.OVERRIDE_FIELDS.VALUE6H') }}
            acrm-input-switch(:value="model.value_6h != null" @input="toggleValue('value_6h', $event)")
    .row.mb-2
        .col-24.col-md-8.col-xl-8
            acrm-input-switch.mt-4(v-model="model.is_percent") {{ $t('ZONES.OVERRIDE_FIELDS.IS_PERCENT') }}
        .col-24.col-md-8.col-xl-8
            acrm-input-switch.mt-4(v-model="model.is_relative") {{ $t('ZONES.OVERRIDE_FIELDS.IS_RELATIVE') }}
    hr
    .row
        .col-12.col-md-auto.ml-auto
            acrm-input-button.block-md-down(variant="light" @click="$router.go(-1)") {{ $t('BASE.BACK')}}
        .col-12.col-md-auto
            acrm-input-button(variant="success" @click="save") {{ $t('BASE.CREATE') }}
</template>
